export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-en-CA.533f8cf1.xlsx";